import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import FuelHero from "@/pages/FuelHero";

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<FuelHero />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
